/* eslint-disable no-param-reassign */
import {
  SEARCH_STOCKS_REQUEST,
  SEARCH_STOCKS_SUCCESS,
  SEARCH_STOCKS_FAILURE,
  GET_STOCKS_REQUEST,
  GET_STOCKS_SUCCESS,
  GET_STOCKS_FAILURE,
  GET_STOCK_REQUEST,
  GET_STOCK_SUCCESS,
  GET_STOCK_FAILURE,
  ADD_STOCK_REQUEST,
  ADD_STOCK_SUCCESS,
  ADD_STOCK_FAILURE,
  UPDATE_STOCK_REQUEST,
  UPDATE_STOCK_SUCCESS,
  UPDATE_STOCK_FAILURE,
  DELETE_STOCK_REQUEST,
  DELETE_STOCK_SUCCESS,
  DELETE_STOCK_FAILURE,
  CLEAR_STOCK
} from "src/actions/stockActions";
import produce from "immer";
import {
  GET_ITEMS_BY_BARCODE_REQUEST,
  GET_ITEMS_BY_BARCODE_SUCCESS,
  GET_ITEMS_BY_BARCODE_FAILURE
} from "src/actions/itemManagementAction";

const initialState = {
  stocks: [],
  stockByBarcode: {},
  stock: {},
  total: 0,
  loading: false
};

const stockReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_STOCKS_REQUEST: {
      return produce(state, (draft) => {
        draft.stocks = [];
        draft.loading = true;
      });
    }

    case SEARCH_STOCKS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.stocks = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case SEARCH_STOCKS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // GET stock list case
    case GET_STOCKS_REQUEST: {
      return produce(state, (draft) => {
        draft.stocks = [];
        draft.loading = true;
      });
    }

    case GET_STOCKS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stocks = response;
        draft.loading = false;
      });
    }

    case GET_STOCKS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // GET stock detail case
    case GET_STOCK_REQUEST: {
      return produce(state, (draft) => {
        draft.stock = {};
        draft.loading = true;
      });
    }

    case GET_STOCK_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stock = response;
        draft.loading = false;
      });
    }

    case GET_STOCK_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // ADD case
    case ADD_STOCK_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case ADD_STOCK_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stations = [...draft.stocks, response];
        draft.loading = false;
      });
    }

    case ADD_STOCK_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // UPDATE case
    case UPDATE_STOCK_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_STOCK_SUCCESS: {
      const {response} = action.payload;
      const updateObj = state.stocks.map((item) => {
        if (item.id === response.id) return response;
        return item;
      });

      if (updateObj !== undefined && updateObj.length > 0) {
        return produce(state, (draft) => {
          draft.stocks = updateObj;
          draft.loading = false;
        });
      }

      return produce(state, (draft) => {
        draft.stocks = [];
        draft.loading = false;
      });
    }

    case UPDATE_STOCK_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // DELETE case
    case DELETE_STOCK_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case DELETE_STOCK_SUCCESS: {
      const {stock} = action.payload;

      return produce(state, (draft) => {
        const {stocks} = draft;
        let filteredStocks;
        if (typeof stock === "object") {
          filteredStocks = stocks.filter((item) => item.id !== stock.id);
        } else {
          filteredStocks = stocks.filter((item) => item.id !== stock);
        }

        draft.stocks = filteredStocks;
        draft.loading = false;
      });
    }

    case DELETE_STOCK_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_STOCK: {
      return produce(state, (draft) => {
        draft.stock = {};
      });
    }

    case GET_ITEMS_BY_BARCODE_REQUEST: {
      return produce(state, (draft) => {
        draft.stockByBarcode = {};
        draft.loading = true;
      });
    }

    case GET_ITEMS_BY_BARCODE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stockByBarcode = response;
        draft.loading = false;
      });
    }

    case GET_ITEMS_BY_BARCODE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default stockReducer;
